import { Card } from "reactstrap";
import { useTranslation } from "react-i18next";
import ZoneSettingsDimensions from "./ZoneSettingsDimensions";
import ZoneSettingsGestion from "./ZoneSettingsGestion";
import ZoneSettingsSitesCollecte from "./ZoneSettingsSitesCollecte";
import ZoneSettingsStatut from "./ZoneSettingsStatut";
import ZoneSettingsNotifications from "./ZoneSettingsNotifications";
import ZoneSettingsAdministrator from "./ZoneSettingsAdministrator";

const ZONE_SETTINGS_CONTENANT_CARD_CLASS =
  "zone-settings__card rounded-lg border border-gray-200 bg-white overflow-hidden";

/**
 * Grille Contenant partagée — création et modification (même disposition / tailles).
 */
const ZoneSettingsContenantGrid = ({
  formData,
  setFormData,
  setErrorForm,
  sites,
  contracts,
  showAdministrator = false,
}) => {
  const { t } = useTranslation();
  const cardClass = ZONE_SETTINGS_CONTENANT_CARD_CLASS;

  return (
    <div className="zone-settings__grid">
      <div className="zone-settings__grid-col zone-settings__grid-col--main">
        <Card className={cardClass}>
          <h3 className="zone-settings__card-title text-lg font-semibold">
            {t("containerSettings.dimensions", {
              defaultValue: "Dimensions",
            })}
          </h3>
          <ZoneSettingsDimensions
            formData={formData}
            setFormData={setFormData}
            setErrorForm={setErrorForm}
          />
        </Card>

        <Card id="zone-settings-gestion" className={cardClass}>
          <h3 className="zone-settings__card-title text-lg font-semibold">
            {t("containerSettings.management")}
          </h3>
          <ZoneSettingsGestion
            formData={formData}
            setFormData={setFormData}
            setErrorForm={setErrorForm}
          />
        </Card>

        <Card className={cardClass}>
          <h3 className="zone-settings__card-title text-lg font-semibold">
            {t("containerSettings.sitesAndCollection")}
          </h3>
          <ZoneSettingsSitesCollecte
            sites={sites}
            contracts={contracts}
            formData={formData}
            setFormData={setFormData}
          />
        </Card>
      </div>

      <div className="zone-settings__grid-col zone-settings__grid-col--side">
        <Card className={cardClass}>
          <h3 className="zone-settings__card-title text-lg font-semibold">
            {t("containerSettings.status", {
              defaultValue: "Statut",
            })}
          </h3>
          <ZoneSettingsStatut formData={formData} setFormData={setFormData} />
        </Card>

        <Card className={cardClass}>
          <h3 className="zone-settings__card-title text-lg font-semibold">
            {t("containerSettings.notifications")}
          </h3>
          <ZoneSettingsNotifications
            formData={formData}
            setFormData={setFormData}
          />
        </Card>

        {showAdministrator ? (
          <Card className={cardClass}>
            <h3 className="zone-settings__card-title text-lg font-semibold">
              {t("Administrator")}
            </h3>
            <ZoneSettingsAdministrator
              formData={formData}
              setFormData={setFormData}
            />
          </Card>
        ) : null}
      </div>
    </div>
  );
};

export default ZoneSettingsContenantGrid;
